import React, { useEffect, useRef, useState } from "react";
import * as Constants from "../constants";
import { useToasts } from "react-toast-notifications";
import DayPickerInput from "react-day-picker/DayPickerInput";
import axios from "axios";

const initialFormData = Object.freeze({
  Id: "",
  FractieId: "",
  MilieustraatId: "",
  TimeSlotId: "",
  Naam: "",
  Email: "",
  Telefoon: "",
  Postcode: "",
  Huisnummer: "",
  Extensie: "",
});

interface IItem extends Constants.IItem {}

interface IItems extends Constants.IItems {}

const AfvalRequest = (props: any) => {
  const { addToast } = useToasts();
  const [sDate, setDate] = useState(props.date);

  let initData = initialFormData;
  if (props.slot !== "") {
    //
  }
  let [reservationid] = React.useState(props.reservationId);
  React.useEffect(() => {
    if (props.existing) {
      Constants.api
        .get(
          "/React/MilieuStraat/GetReservations?straatId=" +
            props.street +
            "&FractieId=" +
            props.fractionId +
            "&date=" +
            Constants.tryFormat(sDate, "dd-MM-yyyy")
        )
        .then((response: any) => {
          //
          response?.data?.Result?.some((reservation: any) => {
            //
            if (reservation.Id === reservationid) {
              let slot = reservation["SelectedTimeslot"];
              delete reservation["SelectedTimeslot"];
              var newData = Constants.ObjectRemoveEmptyProperty(reservation);
              newData.TimeSlotId = slot.Id;
              newData.Huisnummer = newData.HuisNummer;
              delete newData.HuisNummer;

              updateFormData(newData);
            }
            return null;
          });
        });
    }
  }, [reservationid]);

  React.useEffect(() => {}, []);

  const [error, updateError] = React.useState("");
  const [postalerror, updatePostalError] = React.useState("");
  const [executing, updateExecuting] = React.useState(false);

  const [formData, updateFormData] = React.useState(initData);
  const [restformData, updaterestFormData] = React.useState({
    street: "",
    city: "",
  });
  const form = useRef<any>();
  const [sList, setList] = useState<IItems | undefined>([]);

  React.useEffect(() => {
    handlePostal();
  }, [formData.Postcode, formData.Huisnummer, formData.Extensie]);

  const closeModal = () => {
    updateError("");
    updatePostalError("");
    props.close();
  };

  const required = (e: any) => {
    let value = getValue(e);

    setError(e, value === "");
  };

  const setError = (e: any, error: boolean) => {
    let input = getInput(e);
    let parentLabel = input.closest("label");

    if (error) {
      updateError("Een veld is verkeerd / incompleet ingevuld");
      parentLabel.classList.add("error");
    } else {
      updateError("");
      parentLabel.classList.remove("error");
    }
  };

  const getInput = (e: any) => {
    return e?.target ?? document.getElementsByName(e)[0];
  };

  const checkRegex = (value: string, regex: RegExp) => {
    return regex.test(String(value).toLowerCase());
  };

  const getValue = (e: any) => {
    let input = getInput(e);
    return input?.value;
  };
  const checkMail = (e: any) => {
    let correct = checkRegex(
      getValue(e),
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    setError(e, !correct);
    return correct;
  };

  const checkPhone = (e: any) => {
    let correct = checkRegex(
      getValue(e),
      /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
    );
    if (formData.Telefoon.length === 0) {
      correct = true;
    }
    setError(e, !correct);
    return correct;
  };

  const handlePostal = () => {
    if (
      formData.Postcode.length >= 6 &&
      checkRegex(formData.Huisnummer, /\d{1,10}$/)
    ) {
      Constants.api
        .get(
          `/React/MilieuStraat/GetDebiteur?PostalCode=${formData.Postcode}&HouseNumber=${formData.Huisnummer}&Extension=${formData.Extensie}`
        )
        .then((response: any) => {
          let data = response.data;
          if (data?.Success === true) {
            if(data?.Result?.DebiteurInfo?.DoetMee === false)
            {
              updatePostalError("Deze gemeente doet niet mee");
            }else if (data?.Result?.DebiteurInfo?.DebiteurId !== props.debId) {
              updatePostalError("");
              //updatePostalError("WARNING verkeerde gebied"); //TODO aanzetten
            } else {
              updatePostalError("");
            }
            let address = data?.Result?.AddressData;

            if (address?.Street && address?.Street !== "") {
              updaterestFormData({
                ...restformData,
                street: address.Street,
                city: address.City,
              });
            }
          } else {
            updatePostalError(
              "Postcode in combinatie met huisnummer niet gevonden"
            );
          }
        });
    } else if (formData.Postcode.length > 0 && formData.Huisnummer.length > 0) {
      updatePostalError("Incorrecte postcode of huisnummer");
    }
  };

  const handleChange = (e: any) => {
    let input = getInput(e);
    let value = getValue(e).toString();
    updateFormData({
      ...formData,
      [input.name]: value,
    });
  };

  const handleRestChange = (e: any) => {
    let input = getInput(e);
    let value = getValue(e).toString();
    updaterestFormData({
      ...restformData,
      [input.name]: value,
    });
  };

  const checkFields = (data: any, fields: string[]) => {
    for (let field of fields) {
      let value = data[field];
      if (value === "") {
        required(field);
        return false;
      }
    }
    return true;
  };

  const handleRemove = (e: any) => {
    e.preventDefault();
    var answer = window.confirm(
      "Weet u zeker dat u deze reservering wilt verwijderen?"
    );
    if (answer) {
      updateExecuting(true);
      Constants.api
        .post(`/React/MilieuStraat/CancelTimeslot/${reservationid}`)
        .then((response: any) => {
          let data = response.data;
          updateExecuting(false);
          if (data?.Success === true) {
            Constants.ga4react.initialize().then((ga4) => {
              ga4.event("User removed timeslot", "timeslot", props.id);
            });

            closeModal();
            addToast("Reservering is verwijderd", { appearance: "success" });
          } else {
            updateError("Er heeft zich een server error voorgedaan");
          }
        });
    } else {
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (!checkFields(formData, ["Naam", "Email", "Postcode", "Huisnummer"])) {
      updateError("Een veld is verkeerd / incompleet ingevuld");
      return;
    } else {
      updateError("");
    }
    updateExecuting(true);

    let data = { ...formData };
    data.FractieId = props.fractionId;
    if (!props.existing) {
      data.TimeSlotId = props.slot;
    }
    let url = "";
    data.MilieustraatId = props.street;
    if (props.existing) {
      data.Id = props.reservationId;
      url = "UpdateTimeSlot";
    } else {
      url = "SetTimeslot";
    }

    let bodyFormData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      bodyFormData.append(key, value);
    }
    if (error === "" && postalerror === "") {
      Constants.api({
        method: "post",
        url: "/React/MilieuStraat/" + url + "/",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then(
        (response) => {
          updateExecuting(false);
          if (response.data.Errors.length === 0) {
            if (props.existing) {
              Constants.ga4react.initialize().then((ga4) => {
                ga4.event("Updated timeslot", "timeslot", props.id);
              });
            } else {
              Constants.ga4react.initialize().then((ga4) => {
                ga4.event("Added timeslot", "timeslot", props.id);
              });
            }
            addToast(
              "Reservering is " + (props.existing ? "gewijzigd" : "toegevoegd"),
              {
                appearance: "success",
              }
            );
            closeModal();
          } else {
            updateError("Er heeft zich een fout voorgedaan");
          }
        },
        (error) => {
          updateError("Er heeft zich een server fout voorgedaan");
        }
      );
    }
  };

  let straatitem = document.querySelector(".mainmenu .active");
  let straat = "";
  if (straatitem) {
    straat = straatitem.innerHTML;
  }

  let typeitem = document.querySelector("#fractions input:checked");
  var type = "";
  if (typeitem) {
    var label = typeitem.closest("label");
    if (label) {
      type = label.innerText;
    }
  }

  let datumitem = document.querySelector("#datum") as HTMLSpanElement;
  let datum = "";
  if (datumitem) {
    datum = datumitem.innerText;
  }
  const locale = "nl";
  let today: Date = new Date();
  let firstDay: Date = new Date(today.getFullYear() - 1, today.getMonth(), 1);

  let tijd = (props.slot.split("_")[3] ?? "").toString().substring(0, 5);
  const FORMAT = "dd-MM-yyyy";

  function handleDayClick(day: any, modifiers: any) {
    if (modifiers.disabled) {
      return;
    }
    if (!modifiers.selected) {
      setDate(day);
    }
  }

  function handleTimeSlot(e: any) {
    updateFormData({
      ...formData,
      TimeSlotId: e.target.value,
    });
  }

  let cancelList: any = null;
  useEffect(() => {
    if (cancelList) {
      cancelList.cancel("new request");
    }
    if (props.existing && formData.Id === "") {
      return;
    }
    let nItems: IItems = [];
    cancelList = axios.CancelToken.source();
    Constants.api
      .get(
        "/React/MilieuStraat/GetTijdsloten?MilieuStraatId=" +
          props.street +
          "&FractieId=" +
          props.fractionId +
          "&StartDate=" +
          Constants.tryFormat(sDate, "dd-MM-yyyy") +
          "&enddate=" +
          Constants.tryFormat(sDate, "dd-MM-yyyy") +
          "&alwaysFetchTimeslots=true",
        { cancelToken: cancelList.token }
      )
      .then((response: any) => {
        response?.data?.Result?.forEach((date: any) => {
          date.TimeSlots?.forEach((slot: any) => {
            if (slot.Id === formData.TimeSlotId) {
              slot.BeschikbarePlaatsen += 1;
            }
            var SlotAantal = "plek";
            if (slot.BeschikbarePlaatsen > 1) {
              SlotAantal = "plekken";
            }
            let nItem: IItem = {
              id: slot.Id,
              timefrom: slot.StartTijd,
              available: slot.BeschikbarePlaatsen,
              description:
                slot.BeschikbarePlaatsen > 0
                  ? slot.BeschikbarePlaatsen +
                    " " +
                    SlotAantal +
                    " beschikbaar" +
                    (slot.Id === formData.TimeSlotId ? " *" : "")
                  : "Geen plekken beschikbaar",
              existing: false,
              done: false,
            };
            nItems.push(nItem);
          });
        });
        setList(nItems);
      });
  }, [sDate, formData.Id]);

  return (
    <>
      <form ref={form} onSubmit={handleSubmit}>
        <h2 className="no-margin-bottom">
          {datum} - {tijd}u
        </h2>
        <p className="no-margin-top extra-margin-bottom">
          Type: {type}
          <br />
          Locatie: {straat}
        </p>
        <p className="error">{error === "" ? postalerror : error}</p>
        {props.existing && (
          <div className="datetime">
            <div className="left">
              <label>
                <span className="label">Datum *</span>
                <DayPickerInput
                  inputProps={{ readOnly: true }}
                  format={FORMAT}
                  value={Constants.tryFormat(sDate, FORMAT)}
                  formatDate={(date, format) =>
                    Constants.tryFormat(date, format)
                  }
                  dayPickerProps={{
                    disabledDays: [
                      firstDay,
                      { after: firstDay, before: today },
                    ],
                    onDayClick: handleDayClick,
                    showWeekNumbers: true,
                    initialMonth: sDate,
                    selectedDays: sDate,
                    months: Constants.MONTHS[locale],
                    weekdaysLong: Constants.WEEKDAYS_LONG[locale],
                    weekdaysShort: Constants.WEEKDAYS_SHORT[locale],
                    firstDayOfWeek: Constants.FIRST_DAY_OF_WEEK[locale],
                    labels: Constants.LABELS[locale],
                  }}
                />
              </label>
            </div>
            <div className="right">
              <label>
                <span className="label">Tijdstip *</span>
                <select
                  name="TimeSlotId"
                  value={formData.TimeSlotId}
                  onChange={handleTimeSlot}
                >
                  {sList?.map((Item, i) => (
                    <option
                      data-bla={Item.id === formData.TimeSlotId}
                      value={Item.id}
                      disabled={
                        Item.id !== formData.TimeSlotId && Item.available === 0
                      }
                    >
                      {Constants.tryFormat(Item.timefrom, "HH:mm") +
                        " - " +
                        Item.description}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          </div>
        )}
        <div className="left">
          <h2>Persoonlijke gegevens</h2>
          <label>
            <span className="label">Naam *</span>
            <input
              type="text"
              name="Naam"
              value={formData.Naam}
              onChange={(e) => {
                handleChange(e);
              }}
              onBlur={(e) => {
                required(e);
              }}
            />
          </label>
          <label>
            <span className="label">E-mail *</span>
            <input
              type="email"
              name="Email"
              value={formData.Email}
              onChange={(e) => {
                handleChange(e);
              }}
              onBlur={(e) => {
                required(e);
                checkMail(e);
              }}
            />
          </label>
          <label>
            <span className="label">Telefoonnummer</span>
            <input
              type="text"
              name="Telefoon"
              value={formData.Telefoon}
              onChange={(e) => {
                handleChange(e);
              }}
              onBlur={(e) => {
                checkPhone(e);
              }}
            />
          </label>
        </div>
        <div className="right">
          <h2>Adresgegevens</h2>
          <div className="w">
            <label className="w3">
              <span className="label">
                P<span className="hideonsmall">ost</span>c
                <span className="hideonsmall">ode</span> *
              </span>
              <input
                type="text"
                name="Postcode"
                maxLength={8}
                value={formData.Postcode}
                onChange={(e) => {
                  handleChange(e);
                }}
                onBlur={(e) => {
                  required(e);
                }}
              />
            </label>
            <label className="w3">
              <span className="label">
                Huisn<span className="hideonmore">umme</span>r *
              </span>
              <input
                type="number"
                name="Huisnummer"
                maxLength={10}
                value={formData.Huisnummer}
                onChange={(e) => {
                  handleChange(e);
                }}
                onBlur={(e) => {
                  required(e);
                }}
              />
            </label>
            <label className="w3">
              <span className="label">Toevoeging</span>
              <input
                type="text"
                name="Extensie"
                value={formData.Extensie}
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </label>
          </div>
          <label>
            <span className="label">Straatnaam *</span>
            <input
              disabled={true}
              type="text"
              name="street"
              value={restformData.street}
              onChange={(e) => {
                handleRestChange(e);
                required(e);
              }}
            />
          </label>
          <label>
            <span className="label">Plaats *</span>
            <input
              disabled={true}
              type="text"
              name="city"
              value={restformData.city}
              onChange={(e) => {
                handleRestChange(e);
                required(e);
              }}
            />
          </label>
        </div>
        <div className="clearfix"></div>
        <br />
        {props.existing ? (
          <button disabled={executing} className="save" type="submit">
            Reservering wijzigen
          </button>
        ) : (
          <button disabled={executing} className="save" type="submit">
            Reservering bevestigen
          </button>
        )}
        {props.existing && (
          <button
            disabled={executing}
            className="delete"
            onClick={handleRemove}
          >
            Verwijderen
          </button>
        )}
      </form>
    </>
  );
};

export default AfvalRequest;
